/* global window */
// test exponea object
// window.exponea = {
//   identify: (...args) => console.log('exponea initialize', ...args),
//   anonymize: (...args) => console.log('exponea anonymize', ...args),
//   track: (...args) => console.log('exponea track', ...args)
// };

export function exponeaIdentify(userGuid = false) {
  if(window.exponea !== undefined && userGuid) {
    try {
      window.exponea.identify(userGuid);
    } catch(e) { }
  }
}


export function exponeaAnonymize() {
  if(window.exponea !== undefined) {
    try {
      window.exponea.anonymize();
    } catch(e) { }
  }
}

export function exponeaUpdateFavourites(action, range, newFavourites) {
  if(window.exponea !== undefined && action) {
    window.exponea.track('favourites', {
      action,
      range_id: range.rangeNameForUrl,
      range_ids: newFavourites.reduce((ids, fav) => [...ids, fav.rangeNameForUrl], []),
      variant_id: range.catNo,
      variant_ids: newFavourites.map(fav => fav.catNo),
      variant_list: newFavourites.map(fav => ({
        range_id: fav.rangeNameForUrl,
        variant_id: fav.catNo
      }))
    });
  }
}




// WEBPACK FOOTER //
// ./src/services/exponeaService.js